import {writable} from 'svelte/store';

const {set, update, subscribe} = writable({
    device: 'xs',
    docWidth: 0,
    docHeight: 0,
    escapeEventHandlers: [],

    agent_id: 3,
    settings: {},
});

const app = {
    set, update, subscribe,
    windowResize: () => {
        app.update(obj => {
            let win = window;
            let doc = document;
            let docElem = doc.documentElement;
            let body = doc.getElementsByTagName('body')[0];
            obj.docWidth = win.innerWidth || docElem.clientWidth || body.clientWidth;
            obj.docHeight = win.innerHeight || docElem.clientHeight || body.clientHeight;

            if (obj.docWidth > 1199) {
                obj.device = "lg";
            } else if (obj.docWidth > 991) {
                obj.device = "md";
            } else if (obj.docWidth > 767) {
                obj.device = "sm";
            } else {
                obj.device = "xs";
            }

            return obj;
        })
    },
    addEscapeEventHandler: handler => {
        app.update(storeObj => {
            storeObj.escapeEventHandlers = [...storeObj.escapeEventHandlers, handler];
            return storeObj;
        });
    },
    removeEscapeEventHandler: () => {
        app.update(storeObj => {
            if (storeObj.escapeEventHandlers.length) {
                storeObj.escapeEventHandlers = storeObj.escapeEventHandlers.slice(0, -1);
            }
            return storeObj;
        })
    },
}
export default app;